import { AddCircleOutline, DarkModeOutlined, ForumOutlined, JoinRightOutlined, LightModeOutlined, SettingsOutlined } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import * as React from 'react';
import { Link } from 'react-router-dom';
import Chat from './chat';
import Conversation from './conversations';
import NewRoom from './new-room';
import Settings from './settings';
import logo from '../assets/logo.png'
import JoinRoom from './join-room';
import type { RootState } from '../app/store'
import { useSelector } from 'react-redux'

export default function Main () {
	const { active, leftIsOpen } = useSelector((state: RootState) => state.user)
	const [activeLeft, setActiveLeft] = React.useState({ title: "Rooms", icon: <ForumOutlined />, name: 'chats', component: Conversation },);
	const [theme, setTheme] = React.useState(localStorage.theme)
	const tabs = [
		{ title: "Rooms", icon: <ForumOutlined />, name: 'chats', component: Conversation },
		{ title: "New Room", icon: <AddCircleOutline />, name: 'new-room', component: NewRoom },
		{ title: "Join Room", icon: <JoinRightOutlined />, name: 'join-room', component: JoinRoom },
		{ title: "Settings", icon: <SettingsOutlined />, name: 'settings', component: Settings },
	]
	function changeTheme () {
		if (localStorage.theme === 'light')
		{
			document.documentElement.classList.add('dark')
			setTheme('dark');
			localStorage.theme = 'dark'
		}
		else
		{
			document.documentElement.classList.remove('dark')
			setTheme('light');
			localStorage.theme = 'light';

		}
	}
	return (
		<div className='flex h-screen relative text-slate-500 dark:text-slate-300'>
			<div className='flex relative h-full flex-col-reverse sm:flex-row w-full sm:max-w-sm border-r dark:border-slate-600 border-slate-100'>
				<div className='bg-slate-600 absolute sm:static bottom-0 text-xs w-full sm:w-max flex sm:flex-col sm:justify-start justify-around p-2'>
					<Link to="/" className='sm:px-2 hidden sm:inline sm:py-3 my-auto sm:my-0'>
						<Tooltip title={"Quickroom"} placement='right'>
							<IconButton >
								<img src={logo} alt="logo" className="w-6" />
							</IconButton>
						</Tooltip>
					</Link>
					{tabs.map((tab, i) => (
						<span key={tab.name} className='sm:px-2 sm:py-3 my-auto sm:my-0 text-slate-400'>
							<Tooltip title={tab.title} placement='right'>
								<IconButton onClick={() => setActiveLeft(tab)} color={activeLeft.name === tab.name ? 'primary' : 'inherit'}> {tab.icon}</IconButton>
							</Tooltip>
						</span>
					))}
					<span className='sm:absolute bottom-4 left-3'>
						<IconButton onClick={changeTheme}>
							{(theme === 'light' ? <DarkModeOutlined className='text-slate-300' /> : <LightModeOutlined className='text-slate-300' />)}
						</IconButton>
					</span>
				</div>
				<div className='w-full max-h-screen overflow-auto h-full sm:static bg-white text-slate-500 dark:text-slate-300 dark:bg-slate-700 '>
					<activeLeft.component />
				</div>
			</div>
			<div style={{ transition: 'right .5s' }} className={`bg-slate-100 fixed h-full ${leftIsOpen ? '-right-full' : 'right-0'} sm:static w-full flex flex-col dark:bg-slate-700`}>
				{active ?
					<Chat /> :
					<div className='text-2xl text-center my-auto'>
						Open a room to start conversation
					</div>
				}
			</div>
		</div>
	);
}
